import React from 'react';
import { Box } from '@mui/material';
import whatsAppIcon from '../image/logowha.jpg'; 
import { useLanguage } from '../context/LanguageContext';

const FloatingWhatsAppButton = () => {
  const { language, themeMode } = useLanguage();
  const whatsappMessage =
    language === 'en'
      ? 'Hello! I would like more information about SAINZA.'
      : 'Hola! Quisiera mas informacion sobre SAINZA.';

  return (
    <Box
      sx={{
        position: 'fixed',
        bottom: { xs: 14, sm: 18 },
        right: { xs: 14, sm: 20 },
        zIndex: 1000,
        cursor: 'pointer',
        transition: 'transform 0.25s ease',
        '&:hover': {
          transform: 'translateY(-6px) scale(1.04)'
        }
      }}
    >
      <a
        href={`https://api.whatsapp.com/send?phone=593999578916&text=${encodeURIComponent(whatsappMessage)}`}
        target="_blank"
        rel="noopener noreferrer"
        aria-label={language === 'en' ? 'Contact via WhatsApp' : 'Contactar por WhatsApp'}
      >
        <img
          src={whatsAppIcon}
          alt="WhatsApp"
          style={{
            width: '64px',
            height: '64px',
            borderRadius: '50%',
            border: themeMode === 'dark' ? '2px solid rgba(79, 208, 188, 0.52)' : '3px solid rgba(255, 255, 255, 0.75)',
            boxShadow:
              themeMode === 'dark'
                ? '0 16px 25px rgba(7, 20, 24, 0.58)'
                : '0 16px 25px rgba(15, 93, 83, 0.35)',
          }}
        />
      </a>
    </Box>
  );
};

export default FloatingWhatsAppButton;
